import { Atom } from "AppReact";
import styled from "styled-components";

const template = styled.img`
    object-fit: contain;
    padding: 30px;
    width: 220px;
    height: 220px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export default Atom({ type: 'image', dataType: 'string', template });
